import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-bootstrap-modal'
import FlashAlert from '../flash-alert'
import GameDetails from './game-details'
import PaymentModal from '../../containers/payment-modal'
import GameForm from '../facility-open-game-form'

function GameModal(props) {
  const [showForm, setShowForm] = useState(false)
  const alert = props.alert
  const game = props.game

  useEffect(() => {
    props.loadGame(props.gameId)
    return () => { props.clearGame() }
  }, [])

  const sortedPlayerReservations = () => {
    return props.player_reservations.sort((a, b) => {
      return a.pleisystem - b.pleisystem
    })
  }

  const updateGame = (data) => {
    setShowForm(false)
    props.onClose()
  }

  if (!game) return null

  return <Modal container={document.body} show={!!game} onHide={props.onClose} dialogClassName='facilityOpenGameModal'>
    { !!props.payment && 
      <PaymentModal
        game={game}
        playerReservation={props.player_reservations.find(pr => pr.id == props.payment)}
        socketUrl={props.socketUrl}
        onClose={() => props.onClearPayment()}
      /> 
    }
    { showForm && 
      <GameForm 
        id={game.id}
        onClose={() => setShowForm(false)}
        onUpdate={updateGame}
      /> 
    }

    <Modal.Header closeButton>
      <Modal.Title>Open Game</Modal.Title>
    </Modal.Header>

    <Modal.Body>
      { alert && <FlashAlert text={alert.text} type={alert.type} onHide={props.clearAlert} />}
      <GameDetails
        game={game}
        playerReservations={sortedPlayerReservations()}
        onEditPlayerCost={props.onEditPlayerCost}
        onAddPlayer={props.onAddPlayer}
        onPayment={(id) => props.onStartPayment(id)}
        onEdit={() => setShowForm(true)}
      />
    </Modal.Body>
    <Modal.Footer>
      <div className='col-xs-offset-8 col-xs-4 text-right'>
        <button className='btn btn-default' type='button' onClick={props.onClose}>Close</button>
      </div>
    </Modal.Footer>
  </Modal>
}

GameModal.propTypes = {
  gameId: PropTypes.number,
  socketUrl: PropTypes.string,
  game: PropTypes.object,
  player_reservations: PropTypes.array,
  alert: PropTypes.object,
  payment: PropTypes.number,
  loadGame: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  clearGame: PropTypes.func.isRequired,
  showAlert: PropTypes.func.isRequired,
  clearAlert: PropTypes.func.isRequired,
  onEditPlayerCost: PropTypes.func.isRequired,
  onAddPlayer: PropTypes.func.isRequired,
  onStartPayment: PropTypes.func.isRequired,
  onUpdateGame: PropTypes.func.isRequired,
}

export default GameModal
